import React, { useState, useEffect } from "react";
import { fetchLabelValues, generateLabels, fetchShippers,generateZplFile } from "../api/printApi";

export default function PrintLabelPage() {
  const [labelType, setLabelType] = useState("");
  const [shipper, setShipper] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [manualValue, setManualValue] = useState("");
  const [shipperOptions, setShipperOptions] = useState([]);
  const [qty, setQty] = useState(1);
  const [loading, setLoading] = useState(false);

  /* -----------------------------------
     LOAD LABEL VALUES
  ----------------------------------- */
  const loadOptions = async (type) => {
    setLabelType(type);
    setSelectedValue("");
    setManualValue("");
    if (!type) return;

    const res = await fetchLabelValues(type, shipper);
    setOptions(res.data || []);
  };

  /* -----------------------------------
     LOAD SHIPPERS
  ----------------------------------- */
  useEffect(() => {
    fetchShippers()
      .then(res => setShipperOptions(res.data || []))
      .catch(() => setShipperOptions([]));
  }, []);

  /* -----------------------------------
     RELOAD OPTIONS ON SHIPPER CHANGE
  ----------------------------------- */
  useEffect(() => {
    if (labelType) {
      loadOptions(labelType);
    }
  }, [shipper]);

  /* -----------------------------------
     PRINT (PDF ONLY)
  ----------------------------------- */
  const handlePrint = async () => {
    const value = selectedValue || manualValue;

    if (!labelType || !value || qty <= 0) {
      alert("Please fill all required fields");
      return;
    }

    setLoading(true);
    try {
      const res = await generateLabels({
        labelType,
        value,
        quantity: qty
      });

      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url);

    } catch (err) {
      alert("Printing failed");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadZpl = async () => {
  const value = selectedValue || manualValue;

  if (!labelType || !value || qty <= 0) {
    alert("Please fill all required fields");
    return;
  }

  setLoading(true);
  try {
    const res = await generateZplFile({
      labelType,
      value,
      quantity: qty
    });

    const blob = new Blob([res.data], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${labelType}_${value}.zpl`;
    a.click();

    window.URL.revokeObjectURL(url);

  } catch (err) {
    alert("ZPL generation failed");
  } finally {
    setLoading(false);
  }
};


  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.heading}>Print Barcode Labels</h2>

        {/* Label Type */}
        <div style={styles.field}>
          <label style={styles.label}>Label Type *</label>
          <select
            value={labelType}
            onChange={(e) => loadOptions(e.target.value)}
            style={styles.select}
          >
            <option value="">Select</option>
            <option value="ORDER">Dispatch Order</option>
            <option value="SKU">SKU</option>
            <option value="ASN">ASN</option>
          </select>
        </div>

        {/* Shipper */}
        <div style={styles.field}>
          <label style={styles.label}>Shipper Name (Optional)</label>
          <select
            value={shipper}
            onChange={(e) => setShipper(e.target.value)}
            style={styles.select}
          >
            <option value="">All Shippers</option>
            {shipperOptions.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        {/* Available Values */}
        {options.length > 0 && (
          <div style={styles.field}>
            <label style={styles.label}>Select from Available</label>
            <select
              value={selectedValue}
              onChange={(e) => setSelectedValue(e.target.value)}
              style={styles.select}
            >
              <option value="">Select</option>
              {options.map((o) => (
                <option key={o} value={o}>{o}</option>
              ))}
            </select>
          </div>
        )}

        {/* Manual Entry */}
        <div style={styles.field}>
          <label style={styles.label}>Or Enter Manually *</label>
          <input
            value={manualValue}
            onChange={(e) => setManualValue(e.target.value)}
            placeholder="Enter Order / SKU / ASN"
            style={styles.input}
          />
        </div>

        {/* Quantity */}
        <div style={styles.field}>
          <label style={styles.label}>Label Quantity *</label>
          <input
            type="number"
            min="1"
            value={qty}
            onChange={(e) => setQty(e.target.value)}
            style={styles.input}
          />
        </div>

        {/* Action */}
        <button
          onClick={handlePrint}
          disabled={loading}
          style={{
            ...styles.button,
            opacity: loading ? 0.7 : 1
          }}
        >
          {loading ? "Generating..." : "Print Labels"}
        </button>

        <button
          onClick={handleDownloadZpl}
          disabled={loading}
          style={{
            ...styles.button,
            marginTop: "8px",
            background: "#6b7280"
          }}
        >
          Download ZPL
        </button>

      </div>
    </div>
  );
}

/* -----------------------------------
   STYLES
----------------------------------- */
const styles = {
  page: {
    minHeight: "100vh",
    background: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Segoe UI, Arial, sans-serif"
  },
  card: {
    width: "420px",
    padding: "24px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    background: "#fff"
  },
  heading: {
    marginBottom: "20px",
    color: "#dc2626",
    fontSize: "20px",
    fontWeight: "600",
    textAlign: "center"
  },
  field: {
    marginBottom: "14px"
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontSize: "13px",
    color: "#6b7280",
    fontWeight: "500"
  },
  input: {
    width: "100%",
    padding: "9px 10px",
    border: "1px solid #d1d5db",
    borderRadius: "4px",
    fontSize: "14px",
    outline: "none"
  },
  select: {
    width: "100%",
    padding: "9px 10px",
    border: "1px solid #d1d5db",
    borderRadius: "4px",
    fontSize: "14px",
    background: "#fff",
    outline: "none"
  },
  button: {
    width: "100%",
    padding: "10px",
    marginTop: "10px",
    background: "#dc2626",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer"
  }
};
